import { Alert } from "antd";
import { Box, LinearProgress } from "@mui/material";

export default function TabelaTodosDocs({ loadingDocsContext, filesContexto }) {
  return (
    <div className="border">
      {loadingDocsContext ? (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      ) : Array.isArray(filesContexto) && filesContexto.length > 0 ? (
        filesContexto.map((file, index) => {
          // Normaliza separador de pastas (por garantia)
          const normalizedPath = file.replace(/\\/g, "/");

          // Remove tudo até "ordem-" ou "cliente-"
          const shortPath = normalizedPath.replace(
            /^.*?(ordem-\d+|cliente-\d+)/,
            "$1"
          );

          return (
            <div key={index}>
              <div className="files format-file style-bkg" style={{padding: 10}}>
                <span>{shortPath}</span>
              </div>
            </div>
          );
        })
      ) : (
        <div className="alert-message">
          <Alert message="Nenhum documento disponível." type="info" showIcon />
        </div>
      )}
    </div>
  );
}
